export default class CreateScanResponse {

    scan = null;
    isSuccess = null;
    errorMessage = null;
    uploadUrl = null;
    filePath = null;
    expiresOn = null;

    constructor(response){
        this.scan = response.scan;
        this.isSuccess = response.isSuccess;
        this.errorMessage = response.errorMessage;
        this.uploadUrl = response.uploadUrl;
        this.filePath = response.filePath;
        this.expiresOn = response.expiresOn;
    }
}